<template>
    <div class="submit-changes">
      <div class="instructions">
        <div @click="goBack" class="backDiv" style="display: inline-block; margin-top: 10px; margin-left: 10px; margin-right: auto;">
          <i class="pi pi-arrow-left"></i>
          <span> Equipment</span>
        </div>
        <p>A few things before we submit your information:</p>
        <ul>
          <li>You may go back to any previous page to make any other changes prior to submission.</li>
          <li>These changes do not apply to your current active policy - they will be applied to your upcoming renewal.</li>
          <li>Your Reliance Partners insurance representative will reach out to discuss next steps shortly after you’ve submitted this form.</li>
        </ul>
      </div>
      <button @click="submitChanges" class="btn btn-submit">Submit Your Changes <i class="pi pi-send" style="color: black; transform: rotate(45deg);"></i></button>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { useToast } from 'vue-toastification';

  export default {
    name: 'SubmitChanges',
    methods: {
      goBack() {
        // Store the current scroll position
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        // Set a flag in sessionStorage before navigation
        sessionStorage.setItem('scrollToTop', 'true');
        sessionStorage.setItem('previousScrollPosition', scrollPosition);

        // Navigate back
        this.$router.go(-1);
      },
      submitChanges() {
        const toast = useToast();
        const storedData = localStorage.getItem('deruloData');
        if (storedData) {
          const data = JSON.parse(storedData);
          let contactInfo = data.contact_info[0];
          let agencyInfo = data.agency_info[0];
          let contactName = data.primary_contact;
          let clientName = contactInfo.named_insured;
          let marketerEmail = agencyInfo.marketer_email;

          const requestBody = {
            "client_name": clientName,
            "contact_name": contactName,
            "carrier_changes": localStorage.getItem('carrier_changes'),
            "coverage_changes": localStorage.getItem('coverage_changes'),
            "driver_changes": localStorage.getItem('driver_changes'),
            "equipment_changes": localStorage.getItem('equipment_changes'),
            "bdt_email": marketerEmail,
            "cc_email": 'renewalwizard@reliancepartners.com'
          };
          const config = {
            headers: {
              'Content-Type': 'application/json'
            }
          }
          axios.post('/api/clientrenewal/emailexcelfile', requestBody, config)
          .then(response => {
            // Store the data in localStorage
            localStorage.setItem('emailsent', JSON.stringify(response.data));
            // Mark Status Completed
            this.markCompleted();
            // Show success toast
            toast.success('Email sent successfully!', {
              timeout: 5000,
              position: "top-right"
            });
          })
          .catch(error => {
            console.error('Error fetching data:', error);
            // Show error toast
            toast.error('Failed to send the email.', {
              timeout: 5000,
              position: "top-right"
            });
          });

        } else {
          console.error('No data found in localStorage');
        }

          this.$router.push({
          path: '/finishchanges'
        });
      },
      markCompleted() {
        let guid = localStorage.getItem('guid')
        const requestBody = {
          Id: guid,
          status: 2
        };
        const config = {
          headers: {
            'Content-Type': 'application/json'
          }
        };

        axios.put('/api/clientrenewal/updateCompletionStatus', requestBody, config)
        .then(response => {
          console.log('Update successful:', response.data);
        })
        .catch(error => {
          console.error('Error updating completion status:', error);
        });
      }
    }
  }
  </script>
  
  <style scoped>
  i {
    margin-left: 7px;
  }

  .submit-changes {
    text-align: center;
    padding: 15px 30px 20px 30px;
  }
  
  .instructions {
    margin-bottom: 20px;
    text-align: left;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .instructions p {
    font-weight: bold;
  }
  
  .instructions ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .instructions ul li {
    margin-bottom: 10px;
  }
  
  .btn {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .btn-submit {
    background-color: #72933d;
    color: black;
  }
  </style>
  